import { render, staticRenderFns } from "./NewIpModal.vue?vue&type=template&id=63020a26&"
import script from "./NewIpModal.vue?vue&type=script&lang=js&"
export * from "./NewIpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports